import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/rd',
  component: Layout,
  name: 'RdManagement',
  meta: {
    title: '研发管理',
    icon: 'i-ant-design:project-outlined',
    auth: [],
    menuFlatten: true,
    breadcrumb: false,
  },
  children: [
    {
      path: '/development-process',
      name: 'DevelopmentProcess',
      meta: {
        title: '开发流程',
        icon: 'i-ant-design:branches-outlined',
        alwaysOpened: true,
        auth: [
          'repository:list',
          'data-query:list',
          'project:list',
          'requirement:list',
        ],
      },
      children: [
        {
          path: '/repository/index',
          name: 'RepositoryIndex',
          component: () => import('@/views/repository/index.vue'),
          meta: {
            title: '仓库管理',
            icon: 'i-ant-design:database-outlined',
            auth: 'repository:list',
          },
        },
        {
          path: '/data-query/index',
          name: 'DataQueryIndex',
          component: () => import('@/views/data-query/index.vue'),
          meta: {
            title: '数据查询',
            icon: 'i-ant-design:database-outlined',
            auth: 'data-query:list',
          },
        },
        {
          path: '/project/index',
          name: 'ProjectIndex',
          component: () => import('@/views/project/index.vue'),
          meta: {
            title: '项目管理',
            icon: 'i-ant-design:unordered-list-outlined',
            auth: 'project:list',
          },
        },
        {
          path: '/requirement/index',
          name: 'RequirementIndex',
          component: () => import('@/views/requirement/index.vue'),
          meta: {
            title: '需求管理',
            icon: 'i-ant-design:file-text-outlined',
            auth: 'requirement:list',
          },
        },
        {
          path: '/bdd-selection-accuracy-audit/index',
          name: 'BddSelectionAccuracyAuditIndex',
          component: () => import('@/views/bdd-selection-accuracy-audit/index.vue'),
          meta: {
            title: 'BDD选择正确率',
            icon: 'i-ant-design:rise-outlined',
            auth: 'requirement:list',
          },
        },
        {
          path: '/ai-internal-test-audit/index',
          name: 'AiInternalTestAuditIndex',
          component: () => import('@/views/ai-internal-test-audit/index.vue'),
          meta: {
            title: 'AI内测审计',
            icon: 'i-ant-design:line-chart-outlined',
            auth: 'requirement:list',
          },
        },
        {
          path: '/requirement-bdd-scenario/index',
          name: 'RequirementBddScenarioIndex',
          component: () => import('@/views/requirement-bdd-scenario/index.vue'),
          meta: {
            title: 'BDD场景',
            icon: 'i-ant-design:profile-outlined',
            auth: 'requirement:list',
          },
        },
      ],
    },
    {
      path: '/ai-workflow',
      name: 'AiWorkflow',
      meta: {
        title: '自动化流程',
        icon: 'i-ant-design:node-index-outlined',
        alwaysOpened: true,
        auth: [
          'requirement:analysis-task:list',
          'requirement:simple-development-task:list',
          'requirement:acceptance-test-task:list',
          'requirement:auto-merge-task:list',
          'technical-consultation-task:list',
        ],
      },
      children: [
        {
          path: '/technical-consultation/index',
          name: 'TechnicalConsultationIndex',
          component: () => import('@/views/technical-consultation/index.vue'),
          meta: {
            title: '技术咨询',
            icon: 'i-ant-design:file-search-outlined',
            auth: 'technical-consultation-task:list',
          },
        },
        {
          path: '/requirement-analysis/index',
          name: 'RequirementAnalysisIndex',
          component: () => import('@/views/requirement-analysis/index.vue'),
          meta: {
            title: '需求分析',
            icon: 'i-ant-design:fund-projection-screen-outlined',
            auth: 'requirement:analysis-task:list',
          },
        },
        {
          path: '/requirement-simple-development/index',
          name: 'RequirementSimpleDevelopmentIndex',
          component: () => import('@/views/requirement-simple-development/index.vue'),
          meta: {
            title: '简单开发',
            icon: 'i-ant-design:code-outlined',
            auth: 'requirement:simple-development-task:list',
          },
        },
        {
          path: '/acceptance-test/index',
          name: 'AcceptanceTestIndex',
          component: () => import('@/views/acceptance-test/index.vue'),
          meta: {
            title: '自动内测',
            icon: 'i-ant-design:experiment-outlined',
            auth: 'requirement:acceptance-test-task:list',
          },
        },
        {
          path: '/repository-auto-merge/index',
          name: 'RepositoryAutoMergeIndex',
          component: () => import('@/views/repository-auto-merge/index.vue'),
          meta: {
            title: '自动合并',
            icon: 'i-ant-design:merge-cells-outlined',
            auth: 'requirement:auto-merge-task:list',
          },
        },
      ],
    },
    {
      path: '/development-tools',
      name: 'DevelopmentTools',
      meta: {
        title: '开发工具',
        icon: 'i-ant-design:tool-outlined',
        alwaysOpened: true,
        auth: ['development-tool:remote-workstation:list', 'account-pool-monitor:list'],
      },
      children: [
        {
          path: '/remote-workstation/index',
          name: 'RemoteWorkstationIndex',
          component: () => import('@/views/crae/remote-workstation/index.vue'),
          meta: {
            title: '远程工位',
            icon: 'i-ant-design:desktop-outlined',
            auth: 'development-tool:remote-workstation:list',
          },
        },
        {
          path: '/account-pool-monitor/index',
          name: 'AccountPoolMonitorIndex',
          component: () => import('@/views/account-pool-monitor/index.vue'),
          meta: {
            title: '号池监控',
            icon: 'i-ant-design:dashboard-outlined',
            auth: 'account-pool-monitor:list',
          },
        },
      ],
    },
    {
      path: '/requirement/detail/:id',
      name: 'RequirementDetailPage',
      component: () => import('@/views/requirement/detail.vue'),
      meta: {
        title: '需求详情',
        auth: 'requirement:list',
        menu: false,
        activeMenu: '/requirement/index',
      },
    },
    {
      path: '/requirement/create',
      name: 'RequirementCreatePage',
      component: () => import('@/views/requirement/create.vue'),
      meta: {
        title: '新增需求',
        auth: 'requirement:create',
        menu: false,
        activeMenu: '/requirement/index',
      },
    },
  ],
}

export default routes
